import { Injectable, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { distinctUntilChanged, filter, Observable, shareReplay, switchMap, tap } from 'rxjs';
import { ApplicationApiService, UserProfile } from './application-api.service';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  // Inject dependencies
  private readonly oidc = inject(OidcSecurityService);
  private readonly ds = inject(ApplicationApiService);

  // Signal for user state
  readonly user = signal<UserProfile | null>(null);

  // Observable stream for backward compatibility
  readonly user$: Observable<UserProfile>;

  constructor() {
    this.user$ = this.oidc.isAuthenticated$.pipe(
      filter(({ isAuthenticated }) => isAuthenticated === true),
      switchMap(() => this.oidc.getAccessToken()),
      distinctUntilChanged(),
      switchMap(t => this.ds.apiUserProfile()),
      tap(user => this.user.set(user)), // Update signal when user loads
      //map(u => this.transformUser(u)),
      shareReplay(1)
    );
  }

  public isUserApproverForProfitCenter(profitCenterCode: string): boolean {
    const user = this.user();
    if (user && user.profitCentersApproverFor) {
      return user.profitCentersApproverFor.some(pc => pc === profitCenterCode);
    }
    return false;
  }

  public isUserApproverForRegion(regionId: number): boolean {
    const user = this.user();
    if (user && user.regionsApproverFor) {
      return user.regionsApproverFor.some(r => r === regionId);
    }
    return false;
  }

  // private transformUser(u: UserProfileDTO) {
  //   const user: UserProfile = {
  //     ...u,
  //     company: COMPANIES[u.tenantId]
  //   };
  //   return user;
  // }
}
